import { SitesBaseIcon } from '@tableau/icons/SitesBaseIcon';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';

import { Cluster } from '../types/Cluster';
import { AddNewClusterButton } from './AddNewClusterButton';
import { DataConnectMultiClusterTableBody } from './DataConnectMultiClusterTableBody';
import { DataConnectMultiClusterTableHeaders } from './DataConnectMultiClusterTableHeaders';


export type DataConnectMultiClusterSectionProps = Readonly<{
  clusters: Record<string, Cluster>;
  allowCreateCluster: boolean;
  countOfSharedCluster: number;
  siteId: string;
  refreshPoolsAndClusters: () => void;
  hasLoadedPoolsAndClusters: boolean;
}>

export function DataConnectMultiClusterSection(props: DataConnectMultiClusterSectionProps) {
  const existingClusterNames = Object.values(props.clusters).map((cluster: Cluster) => cluster.displayName);
  const clusters: ReadonlyArray<Cluster> = Object.values(props.clusters);
  return (
    <div className={sectionExtraPaddingBottom}>
      <AddNewClusterButton
        existingClusterNames={existingClusterNames}
        siteId={props.siteId}
        refreshEdgePoolsAndClusters={props.refreshPoolsAndClusters}
        hasLoadedEdgePoolsAndClusters={props.hasLoadedPoolsAndClusters}
        allowCreateCluster={props.allowCreateCluster}
      />
      <table className={`${multiClusterTableStyle} tb-static-grid-table-cluster-pool-width`}>
       {clusters.length !==0 && <DataConnectMultiClusterTableHeaders />}
        <DataConnectMultiClusterTableBody
          clusters={props.clusters}
          existingClusterNames={existingClusterNames}
          siteId={props.siteId}
          refreshPoolsAndClusters={props.refreshPoolsAndClusters}
          hasLoadedPoolsAndClusters={props.hasLoadedPoolsAndClusters}
          renderEmptyText={props.countOfSharedCluster===0}
        />
      </table>
      { props.countOfSharedCluster > 0 && <>
        <div>
          <span style={{paddingRight: 4, verticalAlign: 'text-top'}}>
            <SitesBaseIcon size={12} alt={''} />
          </span>
          <span>
            {Messages.dataConnectSiteSettingsClusterCountShared({COUNT_SHARED : props.countOfSharedCluster?.toString()})}
          </span>
        </div>
        </>}
    </div>
  );
}

export const sectionExtraPaddingBottom = style({
  paddingBottom: TabStyles.Spacing.MediumSpace
});

export const multiClusterTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default',
  paddingTop: 10
});
